import isApiError from "@insite/client-framework/Common/isApiError";
import { ApiParameter, del, get, post, request, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { TrainingAndTestingModel } from "@tFissco/ApiModels";

const TrainingAndTestingUrl = "api/v2/email/TrainingAndTesting";

export interface TrainingAndTestingApiParameter extends ApiParameter {
    trainingAndTestingModel: TrainingAndTestingModel;
}

export async function submitTrainingAndTesting(
    parameter: TrainingAndTestingApiParameter,
): Promise<ServiceResult<TrainingAndTestingModel>> {
    try {
        const trainingAndTestingModel = await post<TrainingAndTestingModel>(
            `${TrainingAndTestingUrl}`,
            parameter.trainingAndTestingModel as TrainingAndTestingModel,
        );

        return {
            result: (trainingAndTestingModel as unknown as any).result,
            successful: true,
        };
    } catch (error) {
        if (isApiError(error)) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
                statusCode: error.status,
            };
        }

        throw error;
    }
}
